<template>
    <div class="loader">
        <img src="@/assets/img/loader.png" alt="loader">
    </div>
</template>

<script>
export default {
    name: 'CustomLoaderComponent'
}
</script>

<style lang="scss" scoped>
    .loader{
        animation: rotate  .8s infinite linear;
    }
    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>